export const headerName = {
  add: "Добавить корпус маломерного судна",
  edit: "Редактировать корпус маломерного судна",
};
export const boatBodyMaterialInputs = {
  matname: {
    key: "matname",
    label: "Название материала корпуса маломерного судна",
    type: "text",
    required: true,
  },
  matnote: {
    key: "matnote",
    label: "Примечание",
    type: "text",
  },
};
export const getBoatBodyMaterialInputsInputs = () => boatBodyMaterialInputs;
